// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-modal--MlgrU .modal-body{max-height:50vh !important;max-height:50dvh !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cookie-modal": "cookie-modal--MlgrU"
};
export default ___CSS_LOADER_EXPORT___;
